import { bindFirebaseSession, signInWithSession } from '@dev-factory/firebase-auth'
import { hasRole, startAuth } from '@dev-factory/vue-auth'
import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { Settings } from 'luxon'
import { env } from './env'
import i18n from './i18n'
import { toUserInfos } from './session'

const locale = window.navigator.language.split('-')[0]
if (i18n.global.availableLocales.includes(locale)) i18n.global.locale.value = locale
Settings.defaultLocale = i18n.global.locale.value

const config = {
  apiKey: env.VUE_APP_FIREBASE_API_KEY,
  authDomain: env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VUE_APP_FIREBASE_APP_ID,
  measurementId: env.VUE_APP_MEASUREMENT_ID,
  application: env.VUE_APP_APP_NAME,
  country: env.VUE_APP_COUNTRY
}

export let globalProperties = {}

const app = initializeApp(config)
getAnalytics(app)

const date = new Date().getDate().toString()
if (window.location.pathname === '/tc57') {
  localStorage.setItem('tc57', date)
}
const isTC57 = localStorage.getItem('tc57') === date

const start = async() => {
  // Les TC57 sont des terminaux partagés : sans maintien de session, elle expire sur inactivité.
  const { session } = await startAuth({ keepAlive: !isTC57 })
  const { user: firebaseUser } = await signInWithSession(getAuth())
  bindFirebaseSession(getAuth(), session.value)

  const user = toUserInfos(session.value)
  const roles = session.value.roles

  globalProperties = {
    firebaseUser,
    user,
    roles,
    isTC57,
    isUserFranchise: user.site?.contractType === 'FRA' || user.employeeType === 'Affiliate'
  }

  const createApp = await import(/* webpackChunkName: "createApp" */ './createApp')

  if (hasRole(session.value, 'user')) {
    createApp.createApp({ firebaseUser, user, roles })
  } else {
    createApp.createForbiddenApp({ firebaseUser, userInfos: user, roles })
  }
}

start()
